import { NotificationsService } from '@api';
import { StateContext, Store } from '@ngxs/store';
import { INotificationsStateModel } from '../notifications.state.model';
import { ReadNotification } from './read-notification.actions';

export const readNotification = (_: StateContext<INotificationsStateModel>, action: ReadNotification, store: Store, notificationsService: NotificationsService) => {
    const tenantName = store.snapshot().application.tenantName;
    return notificationsService.readNotification(action.notificationId, tenantName);
};
